import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'form',
    'frame',
    'typeField',
    'correctField',
    'descriptionCorrectField',
    'choiceTag',
    'noField',
    'answerLabel',
    'clearButton',
    'selectorTypeField',
    'selectorCountField',
    'beforeTypeField',
    'beforeSelectorTypeField',
  ];

  static values = {
    choiceAndAnswerFormPath: String,
  };

  typeChanged() {
    this.setCorrectField();
    const formData = new FormData(this.formTarget);
    formData.set('_method', 'POST');

    fetch(this.choiceAndAnswerFormPathValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      body: formData,
    })
    .then(response => response.text())
    .then(html => window.Turbo.renderStreamMessage(html));
  }

  submit() {
    this.setCorrectField();
  }

  setCorrectField() {
    switch (this.typeFieldTarget.value) {
      case 'alternative_test':
      case 'no_particular_order_test':
        this.correctFieldTarget.value = this.checkedChoiceNoValue();
        break;
      case 'description_test':
        this.correctFieldTarget.value = this.descriptionCorrectFieldTargets.filter(t => t.value.length > 0)
                                                                           .map(t => t.value)
                                                                           .join('/');
        break;
    }
  }

  checkedChoiceNoValue() {
    const checkedChoices = this.choiceTagTargets.filter(t => t.checked);

    return checkedChoices.map((t) => {
      let i = this.choiceTagTargets.indexOf(t);

      return this.noFieldTargets[i].value;
    }).join('/');
  }

  // 完全回答テスト
  pickAnswer(event) {
    const correct = this.correctFieldTarget.value;
    const answers = correct.length > 0 ? correct.split('/') : [];

    answers.push(event.target.value);

    this.correctFieldTarget.value = answers.join('/');
    this.answerLabelTarget.innerHTML = this.correctFieldTarget.value;
    this.clearButtonTarget.hidden = false;
  }

  clearAnswers() {
    this.correctFieldTarget.value = '';
    this.answerLabelTarget.innerHTML = '選択してください';
    this.clearButtonTarget.hidden = true;
  }
}
